import { RX0002 } from "../rxTypeCode";
import {callBankSubledgerBalance} from "./dashboardAction";

export const COUNT_BENEFICIARY_VA_REQUEST = "COUNT_BENEFICIARY_VA_REQUEST" + RX0002;
export const COUNT_BENEFICIARY_VA_SUCCESS = "COUNT_BENEFICIARY_VA_SUCCESS" + RX0002;
export const COUNT_BENEFICIARY_VA_FAILURE = "COUNT_BENEFICIARY_VA_FAILURE" + RX0002;

export const RIPPLE_BALANCE_REQUEST = "RIPPLE_BALANCE_REQUEST" + RX0002;
export const RIPPLE_BALANCE_SUCCESS = "RIPPLE_BALANCE_SUCCESS" + RX0002;
export const RIPPLE_BALANCE_FAILURE = "RIPPLE_BALANCE_FAILURE" + RX0002;

export const BANK_SUBLEDGER_BALANCE_REQUEST = "BANK_SUBLEDGER_BALANCE_REQUEST" + RX0002;
export const BANK_SUBLEDGER_BALANCE_SUCCESS = "BANK_SUBLEDGER_BALANCE_SUCCESS" + RX0002;
export const BANK_SUBLEDGER_BALANCE_FAILURE = "BANK_SUBLEDGER_BALANCE_FAILURE" + RX0002;

export const MASTERBALANCE_REQUEST = "MASTERBALANCE_REQUEST" + RX0002;
export const MASTERBALANCE_SUCCESS = "MASTERBALANCE_SUCCESS" + RX0002;
export const MASTERBALANCE_FAILURE = "MASTERBALANCE_FAILURE" + RX0002;

export const VIRTUALACCOUNTSUBACCOUNTBALANCE_REQUEST = "VIRTUALACCOUNTSUBACCOUNTBALANCE_REQUEST" + RX0002;
export const VIRTUALACCOUNTSUBACCOUNTBALANCE_SUCCESS = "VIRTUALACCOUNTSUBACCOUNTBALANCE_SUCCESS" + RX0002;
export const VIRTUALACCOUNTSUBACCOUNTBALANCE_FAILURE = "VIRTUALACCOUNTSUBACCOUNTBALANCE_FAILURE" + RX0002;

export const CUSTOMERTRANSACTION_REQUEST = "CUSTOMERTRANSACTION_REQUEST" + RX0002;
export const CUSTOMERTRANSACTION_SUCCESS = "CUSTOMERTRANSACTION_SUCCESS" + RX0002;
export const CUSTOMERTRANSACTION_FAILURE = "CUSTOMERTRANSACTION_FAILURE" + RX0002;


export const FX_RATE_REF_SUCCESS = "FX_RATE_REF_SUCCESS" + RX0002;
export const FX_RATE_REF_SUCCESS_REGULAR = "FX_RATE_REF_SUCCESS_RAGULAR" + RX0002;
export const FX_RATE_REF_REQ = "FX_RATE_REF_REQ" + RX0002;
export const FX_RATE_REF_FAILURE = "FX_RATE_REF_FAILURE" + RX0002;
